import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../../Style.css";
import AdminHeader from "../../common/Header";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Api from "../../components/api/Api";
import { useSelector } from "react-redux";
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import Tr from "../../components/tr/Tr";

const Subscription = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  
  const serviceApi = Api({
    url: "api/subscription/plan/list",
  });


  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(`${baseUrl}/api/subscription/plan/deletePlan/${itemId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }, 
        }
      );
      console.log(response);
      if (response.data.statusType === "SUCCESS") {
        setData(data.filter((item) => item.id !== itemId));
        showToast("Subscription plan deleted successfully", {
          type: "success",
        });
      } else {
        console.error(
          "Error 'deleting' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error 'deleting' item:", error);
    }
  };

  // Handle Toggle Publish/Disable
  const handleSubscriptionToggle = async (itemId, newStatus) => {
    try {
      // optimistic UI update
      setData((prev) =>
        prev.map((item) =>
          item.id === itemId
            ? { ...item, active: newStatus }
            : item
        )
      );
      console.log("Toggling subscription status", itemId, newStatus);

      await axios.put(
        `${baseUrl}/api/subscription/plan/activateOrDeactivate/${itemId}/${newStatus}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      showToast(
        newStatus
          ? "Subscription plan activated"
          : "Subscription plan deactivated",
        { type: "success" }
      );
    } catch (error) {
      showToast("Failed to update subscription status", {
        type: "error",
      });
      console.error(error);
    }
  };


  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const columns = [
    { displayName: "S.No.", render: (item, index) => ((currentPage-1)*10) + index + 1 },
    { displayName: "Name", key: "plan_name" },
    { displayName: "Code", key: "plan_code" },
    { displayName: "Descroption", key: "plan_description" },
  ];
  
  const fetchData = async (pageNumber = 1) => {
    try {
      const responseData = await serviceApi.fetchData(pageNumber);
      console.log(responseData);
      console.log("your all Subscription type is", responseData);
      setData(responseData.data.subscriptionPlans);
      setTotalPages(responseData.data.totalPage);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const initialValues = {};
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Subscription plans", link: "/subscription-plans", active: true },
  ];
  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          {/* Delete Alert */}
          <BreadCrumb items={breadcrumbItems} />
          <Row>
            <Col lg={3} md={4} sm={12}>
              <AdminHeader />
            </Col>
            <Col lg={9} md={8} sm={12}>
              {data?.length === 0 ? (
                <>
                  <Tr
                    columns={columns}
                    initialValues={initialValues}
                    title="No Services Type Found"
                    buttonName="Create"
                    btnLink="add-all-service-type"
                    titleHeader="Subscription-plans"
                  />
                </>
              ) : (
                <List
                  title="Subscription-plans"
                  data={data}
                  columns={columns}
                  button="Create"
                  route="subscription-plans"
                  to="add-subscription-plans"
                  handleDelete={handleDelete}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  handleSubscriptionToggle={handleSubscriptionToggle}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Subscription;
